import { RootStore, store } from "../store/Store";

/**
 * Convert Crypto
 * @constructor
 */
export const selectFromStore = (selector: "price" | "user" | "general") => {
  const state: RootStore = store.getState();
  return state[selector];
};
export const ConvertCrypto = (
  source: string,
  dest: string,
  amount: any,
  cryptoBasePrice: number
) => {
  const operator = dest.toLowerCase() === "irt" ? "multiply" : "division";
  /**
   * Do Convert Base On Operator
   */
  const convert = (cryptoPrice: number, amount: string) => {
    if (operator === "multiply") {
      const res = cryptoPrice * parseFloat(amount);
      return Math.floor(res);
    } else {
      let tmp: any = parseFloat(amount) / cryptoPrice;
      tmp = tmp.toLocaleString("en", { maximumFractionDigits: 10 });
      return tmp;
    }
  };
  return convert(cryptoBasePrice, amount);
};

/**
 * Convert IRT to USDT By Crypto Symbol
 * @param symbol
 * @constructor
 */
export const ConvertIrtToUsdtBySymbol = (symbol: string) => {
  const sym = symbol.toUpperCase();
  const allPrices = selectFromStore("price");

  //@ts-ignore
  const USDTPrice = allPrices.price[`gold_bullion_1`]["price"];
  //@ts-ignore
  const symbolPrice = allPrices.price[`${sym}`]["price"];

  let result = 1;
  if (symbolPrice !== 0) {
    result = symbolPrice / USDTPrice;
  }
  return result;
};

export const getSymbolIrtPrice = (symbol: string) => {
  const allPrices = selectFromStore("price");
  const sym = symbol.toUpperCase();
  //@ts-ignore
  // const USDTPrice = allPrices.price[`USDT_IRT`]["price"];
  //@ts-ignore
  const symbolPrice = allPrices.price[`${sym}`]["price"];

  // let result = 1;
  // if (symbolPrice != 0) {
  //     result = symbolPrice * USDTPrice;
  // }
  return symbolPrice;
};

export function clearLocalStorage() {
  const PWABannerLastVisibleTime = localStorage.getItem(
    "PWABannerLastVisibleTime"
  );
  localStorage.clear();
  if (PWABannerLastVisibleTime) {
    localStorage.setItem("PWABannerLastVisibleTime", PWABannerLastVisibleTime);
  }
}
